import { BaseAuthState, OrganizationUserMe } from "toptaal-shared"
import { create } from "zustand"
import { persist } from "zustand/middleware"

interface AuthState extends BaseAuthState {
  organizationId: number | null
  setOrganizationId: (organizationId: number) => void
  clearOrganizationId: () => void

  user: OrganizationUserMe | null
  setUser: (user: OrganizationUserMe) => void

  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      refreshToken: null,
      organizationId: null,
      setToken: (token) => set({ token }),
      getToken: () => get().token,
      getRefreshToken: () => get().refreshToken,
      setRefreshToken: (token) => set({ refreshToken: token }),
      setOrganizationId: (organizationId) => set({ organizationId }),
      clearOrganizationId: () => set({ organizationId: null }),

      user: null,
      setUser: (user) => set({ user }),

      logout: () => {
        set({
          token: null,
          refreshToken: null,
          organizationId: null,
          user: null,
        })
      },
    }),
    {
      name: "auth-storage",
    },
  ),
)
